var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FrsFeatureAvatar',_vm._l((_vm.borderPolygons),function(polygon,index){return _c('polygon',{key:index,staticClass:"border",attrs:{"stroke":_vm.borderStroke,"fill":_vm.borderFill,"points":polygon}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }